import { IWatchFullInfoState } from './watchFullInfoContext';
import { WatchFullInfoActionTypes, TWatchFullInfoAction } from './watchFullInfoActions';

export const watchFullInfoReducer = (state: IWatchFullInfoState, action: TWatchFullInfoAction): IWatchFullInfoState => {
	switch (action.type) {
		case WatchFullInfoActionTypes.SET_WATCH_FULL_INFO:
			return {
				...state,
				watchFullInfo: action.payload.watchFullInfo,
			};
		case WatchFullInfoActionTypes.SET_DATA_FOR_PUSH:
			return {
				...state,
				dataForPush: action.payload.dataForPush,
			};
		case WatchFullInfoActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
